import { render, staticRenderFns } from "./SourceSelector.vue?vue&type=template&id=70b866a0&scoped=true"
import script from "./SourceSelector.vue?vue&type=script&lang=js"
export * from "./SourceSelector.vue?vue&type=script&lang=js"
import style0 from "./SourceSelector.vue?vue&type=style&index=0&id=70b866a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b866a0",
  null
  
)

export default component.exports